import { Factory } from './factory';
import { Rect } from '../rect';
import { Position } from '../position';
import { Color } from '../color';

export class RectFactory implements Factory<Rect> {

    buildFromFactory(): Rect {
        return undefined;
    }

    buildFromObject(jsonObject: any): Rect {
        const rect = new Rect();

        rect.id = jsonObject.id;
        rect.pageId = jsonObject.pageId;

        const position = new Position();
        position.x = +jsonObject.position.x;
        position.y = +jsonObject.position.y;
        position.w = +jsonObject.position.w;
        position.h = +jsonObject.position.h;
        rect.position = position;
        rect.updatedAt = jsonObject.updatedAt;
        rect.noteText = jsonObject.noteText;
        rect.color = new Color();
        rect.color.r = +jsonObject.color.r;
        rect.color.g = +jsonObject.color.g;
        rect.color.b = +jsonObject.color.b;
        rect.color.a = +jsonObject.color.a;
        rect.open = jsonObject.open > 0;

        return rect;
    }

}
